import { IColumn, SelectionMode } from "@fluentui/react";
import { RootState } from "app/store";
import CustomDetailList from "components/controls/CustomDetailList";
import { DefaultGridConfig, UpdateColumnByConfig } from "components/controls/CustomDetailList/CustomDetailList";
import { ICustomDetailListConfiguration } from "components/controls/CustomDetailList/ICustomDetailListConfiguration";
import { IGridItem } from "components/controls/CustomDetailList/IGridItem";
import { filterPredicateColumnPropertyName, filterPredicateColumnPropertyString, onRenderColumnRef, sortPredicateColumnPropertyName, sortPredicateColumnPropertyString } from "components/controls/Grid";
import { AppLinkTo, DetailListExcelGenerationAsync } from "global/Application";
import { useApplication } from "global/Application/Context";
import { updateCustomDetailListConfiguration } from "global/Reducer/statusSlice";
import * as FAM from "model/FlexibleAttributeModel";
import { IExtendedColumn } from "model/IExtendedColumn";
import { useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

interface IBenefitGridProps {
    benefits?: FAM.IBenefit[];
}
const BenefitGrid: React.FunctionComponent<IBenefitGridProps> = (props) => {

    const history = useHistory();
    const state = useSelector((state: RootState) => state);
    const application = useApplication();
    const dispatch = useDispatch();

    const storageId = `benefit.grid`;

    const scopeGridConfig = () => {
        const u = state.status.gridConfigs[storageId];
        if (u)
            return u;

        const t = DefaultGridConfig();
        // t.sort = [{ column: { key: 'attributeSetName' }, isSortedDescending: false }];

        return t;
    }

    const [gridConfig, setGridConfig] = useState<ICustomDetailListConfiguration>(scopeGridConfig());
    const gridConfigRef = useRef(gridConfig);

    // check if it has changed since mounting
    if (gridConfig !== gridConfigRef.current) {
        // console.log("render:grid config updated", gridConfig);

        gridConfigRef.current = gridConfig;

        // snapshot for bind back
        dispatch(updateCustomDetailListConfiguration({ id: storageId, gridConfig: structuredClone(gridConfig) }));
    }


    // const [callout, setCallout] = useState(false);
    // const buttonId = useRef({ targetId: '', benefit: null as FAM.IBenefit | null });
    // const onRenderCallout = () => {
    //     if (callout)
    //         return <Callout
    //             className={appStyles.callout}
    //             role="dialog"
    //             beakWidth={0}
    //             gapSpace={0}
    //             target={`#${buttonId.current.targetId}`}
    //             onDismiss={() => setCallout(false)}
    //             setInitialFocus
    //         >
    //             <div style={{ minHeight: '220px' }}>
    //                 <BenefitCallout
    //                     benefit={buttonId?.current?.benefit!}
    //                     mode={EBenefitCardFunction.display}
    //                     contextPlans={state.data.json.plans}
    //                 />
    //             </div>
    //         </Callout>;
    // }


    const columns = useMemo(() => {

        const columns: IExtendedColumn[] = [];

        const onColumnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => {
            setGridConfig(t => {

                const gridConfig: ICustomDetailListConfiguration = { ...t };

                gridConfig.sort = [{
                    column: { key: column.key },
                    isSortedDescending: !t?.sort?.[0]?.isSortedDescending ?? false,
                }];

                return gridConfig;
            });
        };

        // {
        //     const column: ICustomColumn = {
        //         key: 'benefit',
        //         fieldName: 'benefit',
        //         name: '',
        //         minWidth: 10,
        //         onRender: (item?: Record<string, FAM.IBenefit>, index?: number, column?: IColumn) => {
        //             if (!column?.fieldName)
        //                 return <div style={{ textAlign: 'left' }}>---</div>
        //             if (!item)
        //                 return <div style={{ textAlign: 'left' }}>---</div>
        //             const value = item[column.fieldName];

        //             if (value)
        //                 return <IconButton
        //                     id={`IX${index}`}
        //                     iconProps={{ iconName: "comment" }}
        //                     styles={{
        //                         root: { height: 'auto', width: 'auto', paddingTop: '3px' },
        //                         icon: {
        //                             fontSize: '10px',
        //                         }
        //                     }}
        //                     onMouseEnter={() => {
        //                         buttonId.current.targetId = `IX${index}`
        //                         buttonId.current.benefit = item.benefit;
        //                         setCallout(true);
        //                     }}
        //                     onMouseLeave={() => {
        //                         setCallout(false);
        //                     }}
        //                 >
        //                 </IconButton >


        //         }

        //     }
        //     columns.push(column);
        // }

        {
            const column: IExtendedColumn = {
                key: 'benefitRef',
                fieldName: 'benefitRef',
                name: 'Benefit',
                minWidth: 400,
                onRender: onRenderColumnRef
            }

            column.onColumnClick = onColumnClick;
            column.sortPredicate = sortPredicateColumnPropertyName;
            column.filterPredicate = filterPredicateColumnPropertyName;
            UpdateColumnByConfig(column, gridConfig);

            columns.push(column);
        }

        {
            const column: IExtendedColumn = {
                key: 'category',
                fieldName: 'category',
                name: 'Category',
                minWidth: 100,
            }

            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString
            column.filterPredicate = filterPredicateColumnPropertyString;


            columns.push(column);
        }

        {
            const column: IExtendedColumn = {
                key: 'grandFathered',
                fieldName: 'grandFathered',
                name: 'GF/NGF Type',
                minWidth: 150,
            }

            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString
            column.filterPredicate = filterPredicateColumnPropertyString;


            columns.push(column);
        }

        {
            const column: IExtendedColumn = {
                key: 'fundingType',
                fieldName: 'fundingType',
                name: 'Funding Type',
                minWidth: 250,
            }

            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString
            column.filterPredicate = filterPredicateColumnPropertyString;


            columns.push(column);
        }

        {
            const column: IExtendedColumn = {
                key: 'tier',
                fieldName: 'tier',
                name: 'Tier',
                minWidth: 150,
            }

            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString
            column.filterPredicate = filterPredicateColumnPropertyString;


            columns.push(column);
        }

        return columns;
    }, [gridConfig]);

    const benefits = props.benefits ?? state.data.json.benefits;
    const [items, itemsPaged] = useMemo(() => {

        const items: IGridItem<FAM.IBenefit>[] = [];

        const gridConfigMappedColumns = {
            filterColumns: gridConfig.filter.map(q => columns?.find(w => w.key === q.column.key)),
            sortColumns: gridConfig.sort.map(q => columns?.find(w => w.key === q.column.key)),
        }

        const toExtract = (item: IGridItem<FAM.IBenefit>) => () => {
            const eachBenefit = item.data!;

            const row: Record<string, string | undefined> = {
                name: eachBenefit.name,
                benefitRef: eachBenefit.name,
                category: eachBenefit.bcbs_name,
                fundingType: eachBenefit.fundingType?.name,
                grandFathered: eachBenefit.grandFathered?.name,
                tier: eachBenefit.tierSetRef?.name ?? 'N/A',
            }

            return row;
        }

        benefits.forEach((eachBenefit, ix) => {

            // skip deactivated if app is not expecting 
            if ((eachBenefit.deactivated ?? false) !== state.data.json.showInActives?.value)
                return;

            const item: IGridItem<FAM.IBenefit> = {
                _index: ix,
                key: eachBenefit.id!,
                data: eachBenefit,
                name: eachBenefit.name,
                benefitRef: { id: eachBenefit.id, name: eachBenefit.name },
                category: eachBenefit.bcbs_name,
                fundingType: eachBenefit.fundingType?.name,
                grandFathered: eachBenefit.grandFathered?.name,
                tier: eachBenefit.tierSetRef?.name ?? 'N/A',
                benefit: eachBenefit
            };

            item.toExtract = toExtract(item);

            // Filtering :
            let include = true;
            if (gridConfig && gridConfig.filter && gridConfig.filter.length > 0) {

                gridConfig.filter.forEach((filter, ix) => {
                    const column = gridConfigMappedColumns.filterColumns[ix];
                    if (column) {
                        const predicate = column.filterPredicate;
                        if (predicate)
                            include = include && predicate(item, filter.value, column);
                    }
                });
            }

            if (include)
                items.push(item);
        });

        // items.sort((a, b) => { return (a.data?.name ?? '') > (b.data?.name ?? '') ? 1 : -1 });
        if (gridConfig && gridConfig.sort && gridConfig.sort.length > 0)
            items.sort((a, b) => {

                let ret = 0;

                gridConfig.sort?.forEach((sort, ix) => {
                    const column = gridConfigMappedColumns.sortColumns[ix];

                    // TODO why was this needed?
                    if (!column)
                        return;

                    const predicate = column.sortPredicate;
                    const isSortedDescending = sort.isSortedDescending ?? false;

                    if (predicate)
                        ret = isSortedDescending
                            ? predicate(a, b, undefined, column) * -1
                            : predicate(a, b, undefined, column);
                });

                return ret;

            });

        const itemsPaged = items.slice((gridConfig.page - 1) * gridConfig.pageSize, gridConfig.page * gridConfig.pageSize);

        return [items, itemsPaged];

    }, [
        state.data.json.benefits,
        props.benefits,
        gridConfig
    ]);

    return <CustomDetailList
        columns={columns}
        items={items}
        itemsPaged={itemsPaged}
        selectionMode={SelectionMode.none}
        defaultGridConfig={gridConfig}
        quickSearchColumnKey={'benefitRef'}
        onExtract={() => { DetailListExcelGenerationAsync(dispatch, state, application, columns, items) }}
        gridConfig={[gridConfig, setGridConfig]}
        onItemInvoked={(item: IGridItem<FAM.IBenefit>, index, event) => {
            if (item.data)
                history.push(AppLinkTo(state, { id: item.data.id, type: 'benefit' }))
        }}
    />;
}

export default BenefitGrid;
